import React from 'react';

const Careers: React.FC = () => {
  return (
    <div className="min-h-screen bg-tal-slate-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold text-tal-slate-900 mb-4">Join Our Team</h1>
          <p className="text-xl text-tal-slate-700 max-w-3xl mx-auto">
            At Tales and Legends, we're building the future of interactive storytelling.
            Join us on this exciting journey!
          </p>
        </div>

        <div className="bg-white shadow-lg rounded-lg p-8 mb-12 border-t-4 border-tal-brown-500">
          <h2 className="text-2xl font-semibold text-tal-slate-800 mb-4">Why Work With Us?</h2>
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <li className="flex items-start">
              <span className="text-tal-blue-600 mr-3 text-xl">✓</span>
              <span className="text-tal-slate-700">Work on cutting-edge interactive storytelling technology</span>
            </li>
            <li className="flex items-start">
              <span className="text-tal-blue-600 mr-3 text-xl">✓</span>
              <span className="text-tal-slate-700">Collaborative and creative work environment</span>
            </li>
            <li className="flex items-start">
              <span className="text-tal-blue-600 mr-3 text-xl">✓</span>
              <span className="text-tal-slate-700">Remote-friendly opportunities</span>
            </li>
            <li className="flex items-start">
              <span className="text-tal-blue-600 mr-3 text-xl">✓</span>
              <span className="text-tal-slate-700">Competitive compensation and benefits</span>
            </li>
          </ul>
        </div>

        <div className="mb-8">
          <h2 className="text-3xl font-bold text-tal-slate-900 mb-8 text-center">Open Positions</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white shadow-lg rounded-lg overflow-hidden hover:shadow-xl transition-shadow border-t-4 border-tal-brown-500">
              <div className="h-48 bg-gradient-to-br from-tal-brown-600 to-tal-blue-600 flex items-center justify-center">
                <span className="text-white text-6xl">💻</span>
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold text-tal-slate-900 mb-2">Senior Game Developer</h3>
                <p className="text-tal-slate-600 mb-4 h-20">
                  We're looking for an experienced game developer to help build our interactive storytelling platform.
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-tal-slate-500">Full-time • საქართველო </span>
                  <a
                    href="mailto:careers@tales-and-legends.com"
                    className="bg-tal-blue-600 hover:bg-tal-blue-700 text-white font-medium py-2 px-4 rounded transition-colors"
                  >
                    Apply Now
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-white shadow-lg rounded-lg overflow-hidden hover:shadow-xl transition-shadow border-t-4 border-tal-blue-500">
              <div className="h-48 bg-gradient-to-br from-tal-blue-700 to-tal-slate-600 flex items-center justify-center">
                <span className="text-white text-6xl">✍️</span>
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold text-tal-slate-900 mb-2">Narrative Designer</h3>
                <p className="text-tal-slate-600 mb-4 h-20">
                  Join our team to create compelling stories and design engaging narrative experiences.
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-tal-slate-500">Full-time • საქართველო </span>
                  <a
                    href="mailto:careers@tales-and-legends.com"
                    className="bg-tal-blue-600 hover:bg-tal-blue-700 text-white font-medium py-2 px-4 rounded transition-colors"
                  >
                    Apply Now
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-white shadow-lg rounded-lg overflow-hidden hover:shadow-xl transition-shadow border-t-4 border-tal-slate-600">
              <div className="h-48 bg-gradient-to-br from-tal-brown-500 to-tal-brown-700 flex items-center justify-center">
                <span className="text-white text-6xl">🎨</span>
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold text-tal-slate-900 mb-2">UI/UX Designer</h3>
                <p className="text-tal-slate-600 mb-4 h-20">
                  Help us design beautiful and intuitive user interfaces for our gaming platform.
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-tal-slate-500">Contract • საქართველო </span>
                  <a
                    href="mailto:careers@tales-and-legends.com"
                    className="bg-tal-blue-600 hover:bg-tal-blue-700 text-white font-medium py-2 px-4 rounded transition-colors"
                  >
                    Apply Now
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 bg-tal-blue-50 rounded-lg p-6 border-l-4 border-tal-blue-500">
          <p className="text-tal-slate-700">
            Don't see a position that fits? Send us your resume and tell us why you'd be a great addition to our team!
          </p>
        </div>
      </div>
    </div>
  );
};

export default Careers;
